import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { Link as RouterLink } from '@tyro/router/components';
import type { ReactElement } from 'react';

export type TLink = {
  href?: string;
  name: string;
  icon?: ReactElement;
};

type LinkItemProps = {
  link: TLink;
};

export function LinkItem({ link }: LinkItemProps) {
  const { href, name, icon } = link;
  return (
    <Link
      key={name}
      variant="body2"
      component={RouterLink}
      to={href || '#'}
      sx={{
        lineHeight: 2,
        display: 'flex',
        alignItems: 'center',
        color: 'text.primary',
        '& > div': { display: 'inherit' },
      }}
    >
      {icon && (
        <Box sx={{ mr: 1, '& svg': { width: 20, height: 20 } }}>{icon}</Box>
      )}
      {name}
    </Link>
  );
}
